export default {"src":"/_next/static/media/etp.37aa3af0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};